(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7092],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 35793:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutii-finantare/credit-consum-traditional",
      function () {
        return __webpack_require__(58143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 9592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23043);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), settings = ref.publicRuntimeConfig.settings;
var SelectSearch = function(props) {
    var hasError = props.meta && props.meta.touched && props.meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.id,
                className: "\n            Form-label\n            ".concat(props.labelClass && props.labelClass, "\n            ").concat(props.required ? "is-required" : "", "\n            ").concat(props.disabled ? "disabled" : "", "\n          "),
                children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: props.label
                    },
                    className: "inline-block"
                }) : props.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "select-with-search w-full relative ".concat(props.containerClassName),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpread({
                        components: {
                            IndicatorSeparator: function() {
                                return null;
                            },
                            Control: Control,
                            Option: Option,
                            Menu: Menu,
                            IndicatorsContainer: IndicatorsContainer
                        },
                        instanceId: props.id,
                        isDisabled: props.disabled,
                        isClearable: false,
                        hasError: hasError,
                        controlClassName: props.controlClassName,
                        menuPlacement: props.menuPlacement || "top",
                        maxMenuHeight: props.maxMenuHeight || 260,
                        menuShouldScrollIntoView: true,
                        menuClassName: props.menuClassName,
                        placeholder: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-black text-base font-normal leading-18.2",
                            children: props.placeholder
                        }),
                        options: props.options,
                        styles: {
                            valueContainer: function(rest) {
                                return _objectSpread({}, rest, props.valueContainerStyle);
                            }
                        }
                    }, props.input)),
                    props.loadingData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "ui dimmer inverted active",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ui loader"
                        })
                    })
                ]
            }),
            hasError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-red-brand text-sm mt-2px",
                children: props.meta.error
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n        .select-with-search .has-check:after {\n          content: url(".concat(settings.websiteStatics, "/images/check.svg);\n          display: inline-block;\n          float: right;\n        }\n      ")
            })
        ]
    }));
};
var colors = {
    selected: settings.websiteName === "altex" || settings.websiteName === "bricostore" ? "text-red-brand has-check" : "bg-secondary text-white"
};
var Menu = function(_param) {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, selectProps = _param.selectProps, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "selectProps"
    ]);
    var menuClassName = selectProps.menuClassName;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        style: _objectSpread({}, getStyles("menu", rest), {
            marginTop: "-1px",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }),
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({}, menuClassName, menuClassName)),
        children: children
    })));
};
var Control = function(param) {
    var children = param.children, innerRef = param.innerRef, innerProps = param.innerProps, isDisabled = param.isDisabled, isFocused = param.isFocused, selectProps = param.selectProps;
    var controlClassName = selectProps.controlClassName;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({
            "flex rounded-bl-lg rounded-tr-lg justify-between border shadow-inner overflow-hidden": true,
            "border-gray-1100": !selectProps.hasError,
            "border-red-brand bg-red-bg": selectProps.hasError,
            "opacity-50": isDisabled,
            "rounded-b-none": selectProps.hasError || isFocused
        }, controlClassName, controlClassName)),
        style: {
            height: "44px",
            maxWidth: "390px",
            minWidth: "260px",
            background: "white"
        },
        children: children
    })));
};
var Option = function(_param) /*#__PURE__*/ {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, isSelected = _param.isSelected, isFocused = _param.isFocused, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "isSelected",
        "isFocused"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_defineProperty({
            "active:bg-newGray hover:bg-newGray": !isSelected,
            "bg-newGray": isFocused
        }, colors.selected, isSelected)),
        style: _objectSpread({}, getStyles("option", rest), {
            backgroundColor: null,
            color: null
        }),
        children: children
    }));
};
var IndicatorsContainer = function(_param) {
    var children = _param.children, innerRef = _param.innerRef, innerProps = _param.innerProps, getStyles = _param.getStyles, selectProps = _param.selectProps, rest = _objectWithoutProperties(_param, [
        "children",
        "innerRef",
        "innerProps",
        "getStyles",
        "selectProps"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        ref: innerRef
    }, innerProps, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            "rotate-180": selectProps.menuIsOpen
        }),
        style: _objectSpread({}, getStyles("indicatorsContainer", rest)),
        children: children
    })));
};
SelectSearch.defaultProps = {
    id: null,
    label: "",
    required: false,
    disabled: false,
    placeholder: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectSearch);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 58143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ credit_consum_traditional; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./store/stores/actions.js
var actions = __webpack_require__(76208);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Form/SelectSearch.js
var SelectSearch = __webpack_require__(9592);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./store/financing-solutions/actions.js + 1 modules
var financing_solutions_actions = __webpack_require__(82518);
;// CONCATENATED MODULE: ./components/FinancingSolutions/InStoreCreditRequestForm.js













function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var InStoreCreditRequestForm = function(param1) {
    var submitInStoreCreditRequest1 = param1.submitInStoreCreditRequest, customer = param1.customer, stores = param1.stores;
    var ref = (0,react.useState)(false), isSent = ref[0], setIsSent = ref[1];
    var ref1 = (0,react.useState)(false), isSending = ref1[0], setIsSending = ref1[1];
    var formReset = (0,react.useRef)(null);
    var updateFormState = function(subscription) {
        if (subscription.active && isSent) {
            setIsSent(false);
        }
    };
    var handleFormSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(values) {
            var formData, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSending(true);
                        formData = {
                            firstname: values.firstName,
                            lastname: values.lastName,
                            phone: values.phone,
                            store_location_id: values.store
                        };
                        _ctx.next = 4;
                        return submitInStoreCreditRequest1(formData);
                    case 4:
                        response = _ctx.sent;
                        if (response) {
                            setIsSent(true);
                            setIsSending(false);
                            formReset.current({
                                firstName: customer && customer.first_name,
                                lastName: customer && customer.last_name,
                                phone: customer && customer.telephone,
                                store: 0
                            });
                        } else {
                            setIsSending(false);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFormSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                onSubmit: handleFormSubmit,
                initialValues: {
                    firstName: customer && customer.first_name,
                    lastName: customer && customer.last_name,
                    phone: customer && customer.telephone,
                    store: ""
                },
                validate: function(values) {
                    var errors = {};
                    if (values.store && values.store === "") {
                        errors.store = "Te rugam sa selectezi un magazin.";
                    }
                    return errors;
                },
                render: function(param2) {
                    var handleSubmit = param2.handleSubmit, form = param2.form;
                    formReset.current = form.reset;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        id: "credit_request_form",
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* FormSpy */.lP, {
                                onChange: updateFormState,
                                subscription: {
                                    active: true
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    component: InputText/* default */.Z,
                                    id: "in_store_credit_request_first_name",
                                    name: "firstName",
                                    label: "Prenume",
                                    className: "Form-input Form-wide",
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(60))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    component: InputText/* default */.Z,
                                    id: "in_store_credit_request_last_name",
                                    name: "lastName",
                                    label: "Nume",
                                    type: "text",
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(60))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    component: InputText/* default */.Z,
                                    id: "in_store_credit_request_phone",
                                    name: "phone",
                                    label: "Telefon",
                                    type: "tel",
                                    required: true,
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isPhoneNumber */.xT)())
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "store",
                                    id: "in_store_credit_request_store",
                                    component: SelectSearch/* default */.Z,
                                    label: "Magazin",
                                    required: true,
                                    validate: (0,validations/* isRequired */.q9)(),
                                    className: "Form-wide",
                                    placeholder: "Selecteaza un magazin",
                                    parse: function(param) {
                                        var value = param.value;
                                        return value;
                                    },
                                    format: function(id) {
                                        return id && stores ? {
                                            value: id,
                                            label: stores.find(function(store) {
                                                return store.id === id;
                                            }).name
                                        } : null;
                                    },
                                    options: stores && stores.map(function(param) {
                                        var id = param.id, name = param.name;
                                        return {
                                            value: id,
                                            label: name
                                        };
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 mb-6 xs:hidden max-w-[390px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    title: "Vreau sa fiu contactat",
                                    display: "block"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto mt-4 mb-6 hidden xs:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    title: "Vreau sa fiu contactat",
                                    display: "inline"
                                })
                            }),
                            isSending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                                height: 80,
                                children: "Se trimite"
                            })
                        ]
                    }));
                }
            }),
            isSent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    type: "success",
                    showIcon: true,
                    children: "Formularul a fost trimis."
                })
            })
        ]
    }));
};
InStoreCreditRequestForm.propTypes = {
    customer: prop_types_default().shape({
        first_name: (prop_types_default()).string,
        last_name: (prop_types_default()).string,
        telephone: (prop_types_default()).string
    }),
    stores: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired
    })),
    onFormSubmit: (prop_types_default()).func.isRequired
};
/* harmony default export */ var FinancingSolutions_InStoreCreditRequestForm = ((0,es/* connect */.$j)(function(state) {
    return {
        customer: state.user.customer,
        stores: state.stores.data
    };
}, {
    submitInStoreCreditRequest: financing_solutions_actions/* submitInStoreCreditRequest */._C
})(InStoreCreditRequestForm));

// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
;// CONCATENATED MODULE: ./containers/FinancingSolutions/InStoreCredit.js





var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, settings = _publicRuntimeConfig.settings, content = _publicRuntimeConfig.content;
var InStoreConsumerCreditContainer = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: [
                    {
                        id: 1,
                        level: 2,
                        name: "Solutii de finantare",
                        url_key: "solutii-finantare/"
                    },
                    {
                        id: 1,
                        level: 99,
                        name: "Credit de consum"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(settings.websiteStatics, "/images/credex/banner-credit-consum-traditional.png?randomisrandomagainlas"),
                alt: "",
                className: "mt-6 lg:mt-0 w-full rounded-bl-xl rounded-tr-xl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:flex flex-wrap lg:flex-nowrap lg:w-5/6 lg:px-2 mx-auto mt-8 lg:mt-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "w-full lg:grow md:pr-10 text-sm lg:pt-6 pb-4 lg:pb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h1",
                                display: "h1",
                                title: "Creditul de bunuri",
                                classesProp: "mb-4 lg:mb-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-4 lg:mb-6",
                                children: "Sunt lucruri de care ai nevoie acum, lucruri importante, care nu pot fi puse pe lista de asteptare. Si nici nu trebuie."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mb-4",
                                children: [
                                    "Ai la indemana Creditul de bunuri, cu ajutorul caruia poti lua azi tot ce ai nevoie din magazinele ",
                                    content.websiteTitle,
                                    ", USOR, in RATE EGALE."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Oferta noastra"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "list-disc ml-5 mb-4 leading-loose",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Valoarea cumparaturilor pentru care poti obtine finantare:",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " poti imprumuta intre 500 - 24,000 lei"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Perioadele pe care le poti selecta pentru rambursarea sumei imprumutate:",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " 12-36 de luni"
                                        ]
                                    })
                                ]
                            }),
                            "Cum functioneaza:",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                className: "list-decimal ml-5 mb-4 leading-loose",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Alegi produsele dorite"
                                            }),
                                            " din orice magazin",
                                            " ",
                                            content.websiteTitle
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Aplici pentru un credit: direct in magazin"
                                            }),
                                            " la Biroul Credex"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Dupa aprobare, semnezi documentatia de creditare si poti sa pleci acasa, in aceeasi zi, cu bunurile achizitionate in rate."
                                    })
                                ]
                            }),
                            "Care sunt avantajele tale:",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "list-disc ml-5 mb-4 leading-loose",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "RAPIDITATE"
                                            }),
                                            ": Primesti raspuns PE LOC*"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "SIMPLITATE"
                                            }),
                                            ": Aplici direct in magazin, doar cu actul de identitate (in anumite conditii)*"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "ZERO EFORT"
                                            }),
                                            ": Nu este necesar avans sau garantii suplimentare"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "COMODITATE"
                                            }),
                                            ": Platesti ratele ulterior direct in magazin, la casa de marcat, pe baza codului de bare (il gasesti pe tichetul de plata sau pe graficul de rambursare)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] font-semibold",
                                children: "*aplicabil pentru categoriile de persoane (cu titlu de exemplu: salariati) pentru care exista obligatii legale de declarare a veniturilor la autoritatile fiscale, in baza exprimarii acordului de consultare si prelucrare a informatiilor din bazele de date ale Ministerului Finantelor Publice, Agentia Nationala de Administrare Fiscala (ANAF). Pentru celelalte categorii de venituri, este necesara prezentarea documentatiei de venit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "px-4 lg:px-0 lg:w-480px flex-none -mx-15px lg:-mx-4 py-6 text-sm bg-newGray-light lg:rounded-tr-lg lg:rounded-bl-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h1",
                                display: "h1",
                                title: "Formular contact",
                                classesProp: "mb-1 lg:px-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-4 lg:px-10 leading-20",
                                children: "Completeaza datele de mai jos si vei fi contactat in cel mai scurt timp"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border-gray-1100 border-t mt-6 nd:mt-10 pt-6 lg:px-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinancingSolutions_InStoreCreditRequestForm, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:flex flex-wrap lg:flex-nowrap items-center mt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: "mt-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            as: "h1",
                            display: "h1",
                            title: "Exemplu reprezentativ",
                            classesProp: "mb-4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                "Exemplu reprezentativ de calcul, produs cu asigurare de viata atasat:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "In cazul Creditului"
                                }),
                                " Standard 18M/ 24M / Low DAE 48M",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        "(ca urmare a indeplinirii criteriilor de eligibilitate) in valoare de 1.000 / 4.000 / 4.500 Lei cu asigurare de viata cu prima de asigurare unica finantata* de 90 / 480 / 1.080 Lei, adaugata la valoarea creditului, rezultand o valoare totala imprumutata 1.090 / 4.480 / 5.580 Lei pe 18 / 24 / 48 de luni: rata anuala a dobanzii anuale fixa este de 44,5% / 44,5% / 21,5%, comision de analiza dosar 0 Lei, comision lunar de administrare credit 10 Lei, valoarea ratei lunare 96,98 / 304,98 / 187,26 Lei (pentru rate egale, rata incluzand si costul asigurarii de viata cu prima finantata), valoarea totala platibila 1.745,64 / 7.319,39 / 8.988,36 Lei, DAE 90,29% / 67,02% / 28,98% (calculat la valoarea totala imprumutata de 1.090 / 4.480 / 5.580 Lei).",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "italic",
                                    children: "*Prima unica de asigurare de viata finantata de Imprumutator este calculata ca procent de 0,5% din valoarea creditului de 1.000 / 4.000 / 4.500 Lei si inmultita cu perioada de creditare de 18 / 24 / 48 de luni. Costul finantarii de catre Imprumutator a primei unice de asigurare de viata este 39,28 / 278,59 / 566,70 Lei, calculat prin aplicarea ratei dobanzii de 44,5% / 44,5% / 21,5%, la valoarea din credit reprezentand prima unica de asigurare de 90 / 480 / 1.080 Lei finantata de Imprumutator, rezultand o valoare imprumutata de 1.090 / 4.480 / 5.580 Lei."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Exemplu reprezentativ de calcul, produs fara asigurare de viata atasat: ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "In cazul Creditului"
                                }),
                                " Standard 18M / 24M / 36M/ Low DAE 48M",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "(ca urmare a indeplinirii criteriilor de eligibilitate) pentru o valoare totala a creditului de 1.000 / 4.000 / 6.000 / 4.500 Lei pe 18 / 24 / 36 / 48 de luni: rata dobanzii fixa / an este de 52,5% / 52,5% / 52,5% / 29,5%, comision de analiza dosar 0 Lei, comision lunar de administrare credit 10 Lei, valoarea ratei lunare 94,72 / 293,56 / 366,20 / 174,45 Lei (pentru rate egale), valoarea totala platibila 1.704,91 / 7.045,36 / 11.408,33 / 8.373,49 Lei, DAE 109,07% / 82,27% / 59,67% / 40,73%."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var InStoreCredit = (InStoreConsumerCreditContainer);

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
;// CONCATENATED MODULE: ./pages/solutii-finantare/credit-consum-traditional.js







function credit_consum_traditional_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function credit_consum_traditional_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                credit_consum_traditional_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                credit_consum_traditional_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var credit_consum_traditional_InStoreCredit = function(param) {
    var stores = param.stores;
    if (stores) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Credit de consum"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InStoreCredit, {})
            ]
        }));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
            children: "Pagina nu este disponibila in acest moment."
        }));
    }
};
credit_consum_traditional_InStoreCredit.pageLayout = "default";
credit_consum_traditional_InStoreCredit.getInitialProps = (function() {
    var _ref = credit_consum_traditional_asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var reduxStore, stores, promises;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = ctx.reduxStore;
                    stores = reduxStore.getState().stores.data;
                    promises = [];
                    if (!stores) promises.push(reduxStore.dispatch((0,actions/* getStores */.r8)()));
                    _ctx.next = 6;
                    return Promise.all(promises);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ var credit_consum_traditional = ((0,es/* connect */.$j)(function(state) {
    return {
        stores: state.stores.data
    };
})(credit_consum_traditional_InStoreCredit));


/***/ }),

/***/ 82518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eC": function() { return /* binding */ getLoanSimulation; },
  "_C": function() { return /* binding */ submitInStoreCreditRequest; },
  "KP": function() { return /* binding */ submitOnlineCreditRequest; }
});

;// CONCATENATED MODULE: ./store/financing-solutions/constants.js
var SUBMIT_IN_STORE_CREDIT_REQUEST = "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST";
var SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS = "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS";
var SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE = "FINANCING-SOLUTIONS/SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE";
var SUBMIT_ONLINE_CREDIT_REQUEST = "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST";
var SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS = "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS";
var SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE = "FINANCING-SOLUTIONS/SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE";
var GET_LOAN_SIMULATION = "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION";
var GET_LOAN_SIMULATION_SUCCESS = "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION_SUCCESS";
var GET_LOAN_SIMULATION_FAILURE = "FINANCING-SOLUTIONS/GET_LOAN_SIMULATION_FAILURE";

// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
;// CONCATENATED MODULE: ./store/financing-solutions/actions.js



var submitInStoreCreditRequest = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: SUBMIT_IN_STORE_CREDIT_REQUEST,
                success: SUBMIT_IN_STORE_CREDIT_REQUEST_SUCCESS,
                fail: SUBMIT_IN_STORE_CREDIT_REQUEST_FAILURE
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se trimite cererea...",
            alert: true,
            alertMessage: "Error sending request",
            apiCall: api/* submitInStoreCreditRequestApi */.J0i,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};
var submitOnlineCreditRequest = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: SUBMIT_ONLINE_CREDIT_REQUEST,
                success: SUBMIT_ONLINE_CREDIT_REQUEST_SUCCESS,
                fail: SUBMIT_ONLINE_CREDIT_REQUEST_FAILURE
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se trimite cererea...",
            alert: true,
            alertMessage: "Eroare la trimiterea solicitarii",
            apiCall: api/* submitOnlineCreditRequestApi */.rFX,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};
var getLoanSimulation = function(values) {
    return function(dispatch, getState) {
        return (0,helpers/* makeApiCall */.Vo)({
            actions: {
                action: GET_LOAN_SIMULATION,
                success: GET_LOAN_SIMULATION_SUCCESS,
                fail: GET_LOAN_SIMULATION_FAILURE
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se trimite cererea...",
            alert: false,
            alertMessage: "Eroare la trimiterea solicitarii",
            apiCall: api/* getLoanSimulationApi */.caK,
            apiArgs: [
                values
            ],
            formatResponse: function(response) {
                return response.data;
            },
            returnResponse: true
        });
    };
};


/***/ }),

/***/ 76208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r8": function() { return /* binding */ getStores; },
/* harmony export */   "y3": function() { return /* binding */ getStoreByUrlPath; },
/* harmony export */   "MM": function() { return /* binding */ getLockersList; }
/* harmony export */ });
/* unused harmony export getUserLocation */
/* harmony import */ var _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69170);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2642);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);




var getStores = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES */ .lc,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_SUCCESS */ .B6,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_FAILURE */ .Md
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            // spinnerMessage: "Loading stores list",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoresApi */ .n5p,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.stores;
            }
        });
    };
};
var getStoreByUrlPath = function(urlPath) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH */ .fw,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_SUCCESS */ .F0,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_FAILURE */ .o8
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se incarca lista magazinelor",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoreByUrlPathApi */ .XM9,
            apiArgs: [
                encodeURIComponent(urlPath)
            ],
            formatResponse: function(response) {
                return {
                    store: response.data.stores[0]
                };
            }
        });
    };
};
var getUserLocation = function() {
    return function(dispatch) {
        // Dispatch get user location action
        dispatch({
            type: GET_USER_LOCATION
        });
        // Check if browser has geolocation support and is enabled
        getBrowserGeolocation().then(function(result) {
            dispatch({
                type: GET_USER_LOCATION_SUCCESS,
                payload: result
            });
        }).catch(function(error) {
            // Catch error and dispatch get user location failure
            dispatch({
                type: GET_USER_LOCATION_FAILURE,
                error: error.message
            });
        });
    };
};
var getLockersList = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST */ .nv,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_SUCCESS */ .DP,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_FAILURE */ .IM
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getLockersApi */ .p5Y,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.data.lockers;
            }
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3043,9774,2888,179], function() { return __webpack_exec__(35793); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);